(function(){
  'use strict';

  function clean(value){return String(value==null?'':value).replace(/\s+/g,' ').trim()}
  function hosts(){return Array.from(document.querySelectorAll('[data-rk-product-config-preview]'))}
  function escapeAttr(value){return String(value||'').replace(/&/g,'&amp;').replace(/"/g,'&quot;').replace(/</g,'&lt;').replace(/>/g,'&gt;')}
  function visible(el){if(!el||el.hidden)return false;const style=getComputedStyle(el);const rect=el.getBoundingClientRect();return style.display!=='none'&&style.visibility!=='hidden'&&rect.width>0&&rect.height>0}
  function amountText(detail){return clean(detail&&(
    detail.price||detail.salePrice||detail.price_text||detail.total_text||
    (detail.configuration&&detail.configuration.price)
  ))}
  function detailCaption(detail){
    if(!detail)return 'Aktuelle Konfiguration';
    const cfg=detail.configuration||{};
    return [detail.product_title||detail.product||detail.title,cfg.color||detail.color,cfg.size||detail.dimension||detail.size,cfg.edging||detail.edging,cfg.extras||detail.extras]
      .map(clean).filter(v=>v&&v!=='—'&&v!=='nicht aktiv').join(' · ')||'Aktuelle Konfiguration';
  }
  function imageList(detail){
    if(!detail)return [];
    const list=[];
    const add=value=>{const src=clean(value);if(src&&!list.includes(src))list.push(src)};
    (Array.isArray(detail.preview_images)?detail.preview_images:[]).forEach(add);
    add(detail.preview_image);add(detail.carpet_image);add(detail.edging_image);add(detail.sketch_image);
    const cfg=detail.configuration||{};add(cfg.preview_image);add(cfg.edging_image);
    return list;
  }
  function showHtml(html,caption){
    if(!html)return;
    hosts().forEach(host=>{
      const visual=host.querySelector('[data-rk-product-config-preview-visual]');
      const cap=host.querySelector('[data-rk-product-config-preview-caption]');
      if(!visual)return;
      visual.innerHTML=html;
      if(cap)cap.textContent=clean(caption)||'Aktuelle Konfiguration';
      host.hidden=false;
    });
  }
  function showImages(images,caption){
    const valid=(images||[]).filter(Boolean).slice(0,2);
    if(!valid.length)return false;
    const html=valid.map((src,index)=>{
      const role=index===0?'carpet':'edging';
      return '<figure class="rk-product-config-preview__image-frame rk-product-config-preview__image-frame--'+role+'">'+
        '<img src="'+escapeAttr(src)+'" alt="" loading="lazy" data-rk-config-preview-image="'+index+'" data-rk-config-preview-role="'+role+'">'+
      '</figure>';
    }).join('');
    showHtml('<div class="rk-product-config-preview__images">'+html+'</div>',caption);
    return true;
  }
  function showImage(src,caption){return showImages(src?[src]:[],caption)}
  function reset(){
    hosts().forEach(host=>{host.hidden=true;const visual=host.querySelector('[data-rk-product-config-preview-visual]');if(visual)visual.innerHTML='';const cap=host.querySelector('[data-rk-product-config-preview-caption]');if(cap)cap.textContent=''});
    const currentHandle=currentProductHandle();
    try{
      sessionStorage.removeItem('rk_current_configuration');
      if(currentHandle)sessionStorage.removeItem('rk_configuration_'+currentHandle);
    }catch(error){}
    if(!window.RKCurrentConfiguration||matchesPage(window.RKCurrentConfiguration))window.RKCurrentConfiguration=null;
  }
  function extract(scope,caption){
    if(!scope)return false;
    const svg=Array.from(scope.querySelectorAll('svg')).find(visible);
    if(svg){showHtml(svg.outerHTML,caption);return true}
    const candidates=['[data-rk-at-preview-color]','[data-rk-at-preview-edging]','[data-rk-maglia-preview] img','[data-tk-preview] img','.rk-at-preview img','.rk-maglia__drawing img','.rk-rb-sketch img'];
    const images=[];
    candidates.forEach(selector=>Array.from(scope.querySelectorAll(selector)).forEach(img=>{if(visible(img)){const src=img.currentSrc||img.src;if(src&&!images.includes(src))images.push(src)}}));
    return showImages(images,caption);
  }
  function setPrice(price){
    const text=clean(price);if(!text)return;
    document.querySelectorAll('[data-tk-summary-price],[data-tk-sticky-price],[data-rk-configured-price]').forEach(el=>{el.textContent=text;el.hidden=false});
    window.dispatchEvent(new CustomEvent('tk:price:update',{detail:{price:text,source:'configuration'}}));
  }
  function setSummary(detail){
    const caption=detailCaption(detail);
    document.querySelectorAll('[data-tk-summary],[data-rk-selected-configuration],[data-rk-sticky-configurator-summary],[data-rk-product-sticky-config]').forEach(el=>{el.textContent=caption;el.hidden=false});
    setPrice(amountText(detail));
  }
  function handleFromUrl(value){
    try{
      const url=new URL(value||window.location.href,window.location.origin);
      const match=url.pathname.match(/\/products\/([^/?#]+)/i);
      return match?decodeURIComponent(match[1]):'';
    }catch(error){return ''}
  }
  function currentProductHandle(){
    const bodyHandle=clean(document.body&&document.body.dataset&&document.body.dataset.productHandle);
    if(bodyHandle)return bodyHandle;
    const canonical=document.querySelector('link[rel="canonical"]');
    return handleFromUrl(canonical&&canonical.href)||handleFromUrl(window.location.href);
  }
  function detailProductHandle(detail){
    return clean(detail&&(detail.product_handle||detail.source_product_handle))||handleFromUrl(detail&&(detail.product_url||detail.source_product_url));
  }
  function matchesPage(detail){
    if(!detail)return false;
    const currentHandle=currentProductHandle();
    const detailHandle=detailProductHandle(detail);
    if(currentHandle&&detailHandle)return currentHandle===detailHandle;
    return true;
  }
  function persist(detail){
    try{
      sessionStorage.setItem('rk_current_configuration',JSON.stringify(detail));
      const key=clean(detail.product_handle||detail.source_product_handle||detail.product_id||detail.source_product_id);
      if(key)sessionStorage.setItem('rk_configuration_'+key,JSON.stringify(detail));
    }catch(error){}
  }
  function apply(detail,scope){
    if(!detail||typeof detail!=='object'||!matchesPage(detail))return;
    window.RKCurrentConfiguration=detail;
    persist(detail);
    const caption=detailCaption(detail);
    const images=imageList(detail);
    if(detail.preview_svg)showHtml(detail.preview_svg,caption);
    else if(!showImages(images,caption))extract(scope||document.querySelector('.rk-at-modal.is-open,[data-rk-at-modal].is-open,.rk-maglia__modal.is-open,.rk-rb-modal.is-open'),caption);
    setSummary(detail);
  }
  function eventDetail(event){
    const raw=event&&event.detail||{};
    return raw.payload&&typeof raw.payload==='object'?raw.payload:raw;
  }
  function eventScope(event){
    const raw=event&&event.detail||{};
    if(raw.scope)return raw.scope;
    if(raw.prefix){try{return document.querySelector('[data-tk="'+CSS.escape(raw.prefix)+'"]')}catch(error){}}
    return null;
  }

  window.addEventListener('rk:product-preview:update',function(event){
    const detail=event.detail||{};
    if(detail.reset){reset();return}
    if(detail.configuration||detail.details||detail.price){apply(detail,detail.scope);return}
    if(detail.svg){showHtml(detail.svg,detail.caption);return}
    if(detail.image){showImage(detail.image,detail.caption);return}
    if(detail.scope)extract(detail.scope,detail.caption);
  });
  ['tk:configuration:apply','rk:configuration:updated','rk:configuration:applied','rk:configuration:buy'].forEach(name=>{
    window.addEventListener(name,function(event){apply(eventDetail(event),eventScope(event))});
    document.addEventListener(name,function(event){apply(eventDetail(event),eventScope(event))});
  });
  document.addEventListener('click',function(event){if(event.target&&event.target.closest&&event.target.closest('[data-rk-at-reset],[data-tk-reset],[data-rk-maglia-reset],[data-rk-rb-reset]'))reset()});
  function restore(){
    let detail=null;
    const currentHandle=currentProductHandle();
    try{
      if(currentHandle)detail=JSON.parse(sessionStorage.getItem('rk_configuration_'+currentHandle)||'null');
      if(!detail)detail=JSON.parse(sessionStorage.getItem('rk_current_configuration')||'null');
    }catch(error){}
    if(detail&&matchesPage(detail))apply(detail,null);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',restore,{once:true});else restore();
})();
